import { render, staticRenderFns } from "./project.vue?vue&type=template&id=5b42fd32&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/project.css?vue&type=style&index=0&id=5b42fd32&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b42fd32",
  null
  
)

export default component.exports